import { useState, useEffect } from "react";
import {
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Button,
    Typography,
    Input,
} from "@material-tailwind/react";
import MaterialIcon from "components/material-icon";

export default function AddNewThemeDialog({
    open,
    onClose,
    onAddNewTheme, // (newThemeName) => {} callback to parent modal
}) {
    const [themeName, setThemeName] = useState("");

    const handleClose = () => {
        onClose();
    };

    const handleAdd = () => {
        if (!themeName.trim()) return;
        onAddNewTheme(themeName.trim());
        setThemeName("");
        handleClose();
    };

    const handleClear = () => setThemeName("");

    // Reset input when dialog opens
    useEffect(() => {
        if (open) setThemeName("");
    }, [open]);

    return (
        <Dialog open={open} handler={handleClose} className="dialog">
            <DialogHeader className="dialog__header">
                <Typography variant="h4">Add New Theme</Typography>
            </DialogHeader>

            <DialogBody className="dialog__body">
                <div className="dialog__section flex items-center gap-2">
                    <div className="relative flex-1">
                        <Input
                            type="text"
                            label="New Theme Name"
                            value={themeName}
                            onChange={(e) => setThemeName(e.target.value)}
                            placeholder="Type new Theme name"
                            className="font-body"
                        />
                        {themeName && (
                            <MaterialIcon
                                name="close"
                                className="absolute right-2 top-1/2 transform -translate-y-1/2 cursor-pointer text-gray-500"
                                onClick={handleClear}
                            />
                        )}
                    </div>
                </div>
            </DialogBody>

            <DialogFooter className="dialog__footer">
                <Button
                    type="button"
                    className="btn btn--danger"
                    onClick={handleClose}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    className="btn btn--primary"
                    onClick={handleAdd}
                    disabled={!themeName.trim()}
                >
                    Add New Theme
                </Button>
            </DialogFooter>
        </Dialog>
    );
}
